var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9148_844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07153 8.56204C7.33864 8.93287 7.67942 9.23971 8.07076 9.46174C8.4621 9.68378 8.89485 9.81581 9.33965 9.84889C9.78445 9.88197 10.2309 9.81533 10.6487 9.65347C11.0665 9.49162 11.4459 9.23834 11.7612 8.91082L13.6271 6.97311C14.1936 6.36402 14.5071 5.54823 14.5 4.70146C14.4929 3.85469 14.1658 3.04469 13.5892 2.44591C13.0127 1.84713 12.2327 1.50748 11.4173 1.50012C10.6019 1.49276 9.81631 1.81828 9.22978 2.40657L8.15999 3.51106",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92857 7.43796C8.66146 7.06713 8.32068 6.76029 7.92934 6.53826C7.538 6.31622 7.10525 6.18419 6.66045 6.15111C6.21565 6.11803 5.7692 6.18467 5.35139 6.34653C4.93357 6.50838 4.55416 6.76166 4.23889 7.08918L2.37298 9.02689C1.80649 9.63598 1.49303 10.4518 1.50012 11.2985C1.5072 12.1453 1.83426 12.9553 2.41086 13.5541C2.98745 14.1529 3.76745 14.4925 4.58284 14.4999C5.39824 14.5072 6.1838 14.1817 6.77032 13.5934L7.8339 12.4889",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9148_844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/Inventory_icon.e68797aa19f34072c397f6fec38bdb02.svg";
export { ForwardRef as ReactComponent };